import { render } from "./PersonalPassword.vue?vue&type=template&id=dda35f36"
import script from "./PersonalPassword.vue?vue&type=script&lang=js"
export * from "./PersonalPassword.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\ekk-hrm-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__